/*!

=========================================================
* 　テンプレート
=========================================================
*/
import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardTitle,
  Table,
  Row,
  Col,
  Modal, ModalBody, ModalFooter
} from "reactstrap";

import InputText from '../FormParts/InputText';
import SystemInfo from '../ViewParts/SystemInfo';
import CustomTd from '../ViewParts/CustomTd';
import Request from '../../common/Request';
import WithRole from '../FormParts/ButtonWithRole';
import InputRadio from "../FormParts/InputRadio";
import InputDatetime from "../FormParts/InputDatetime";
import { getErrorCodes } from "../../variables/message";
import AdminCustomerSelectPopup from '../ViewParts/AdminCustomerSelectPopup';
import InputCheckBox from "../FormParts/InputCheckBox";
import FormatCode from '../../common/FormatCode';
import ApprovedInfo from '../ViewParts/ApprovedInfo';

import {
  cst_customer_agreement_status,
  cst_construction_number_require_flag,
  cst_customer_system_use_flag,
  cst_cu_customer_option_approval,
  cst_cu_customer_option_approval_step,
  cst_cu_customer_option_data_scope,
  cst_customer_natural_flag,
  cst_customer_branch_update_type
} from '../../variables/codes_map';
import InputSelect from "../FormParts/InputSelect";

import { customMessages, GetMessage } from "../../variables/message"
import delete_support_flg from "../../variables/settings"
const domain = "";
const moment = require("moment");

class Regist extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      valid: true,
      regist_modal: false,
      branch_regist_modal: false,
      test_delete_modal: false,
      error_modal: false,
      data: {
        values:{
          construction_number_require_flag : cst_construction_number_require_flag[0].default,
          customer_system_use_flag: cst_customer_system_use_flag[0].default,
          customer_agreement_status: cst_customer_agreement_status[0],
          customer_system_start_date: "",
          customer_system_end_date: "",
          customer_branch_update_type: cst_customer_branch_update_type[0].default,
          admin_user_login_id: "",
        },
        errors:{},
        requiredData:{}
      },
      view: false,
      new_customer_id: "",
      options_branch: [],
      delete_support_flg: false
    };
    this.toggleRegistModal = this.toggleRegistModal.bind(this);
    this.toggleBranchRegistModal = this.toggleBranchRegistModal.bind(this);
    this.validateCallback = this.validateCallback.bind(this)
    this.customer_select_popup = React.createRef();
    this.toggleDeleteModal = this.toggleDeleteModal.bind(this);
    this.customerSelected = this.customerSelected.bind(this)
    this.GetCustomerLoginId = this.GetCustomerLoginId.bind(this)
    this.alertNaturalIdCheck = this.alertNaturalIdCheck.bind(this)
  }
  // 初期ロード用
  componentDidMount() {
    /*　ここは開発者が記述　*/
    const employeeType =  parseInt(localStorage.employee_type)
    const url = domain + '/api/customer';
    if(this.props.match.params.customer_id != undefined){
      Request.get(url + '/' + this.props.match.params.customer_id, {},res => {
        const {customer_natural_id}  = res.Data
        console.log(customer_natural_id,delete_support_flg);
        const test_customer = customer_natural_id != undefined && delete_support_flg.filter((s)=>customer_natural_id == s);
        const delete_check = test_customer.length > 0

        this.setState({
          data:{
            ...this.state.data,
            values:{
              ...res.Data,
              admin_user_login_id: res.Data["admin_user_login_id"] == null ? "":  res.Data["admin_user_login_id"],
              customer_system_start_date: res.Data["customer_system_start_date"] == null ? "":  res.Data["customer_system_start_date"],
              customer_system_end_date: res.Data["customer_system_end_date"] == null ? "":  res.Data["customer_system_end_date"],
              customer_branch_update_type: 0,
            }
          },
          view:true,
          employeeType: employeeType,
          updateCoreUser:true,
          delete_support_flg: delete_check
        });
        const lastUpdateUrl = domain + '/api/landmark/lastupdate/' ;
        var params = {};
        Request.get(lastUpdateUrl + res.Data.lastupdate_user_id, params, res => {
          this.setState({
            data:{
              ...this.state.data,
              values:{
                ...this.state.data.values,
                lastupdate_user: res.Data,
              }
            }
          }, ()=>{
            this.setRequiredData(url)
            this.ButtonWithRole = WithRole(Button, this.props.buttons, this.state.data.values)
          });
        });

        /* 一覧請求　支店情報の取得 */
        Request.get("/api/customer/branch/setting",{customer_id:res.Data.id},(res)=>{
          console.log(res.Data)
          if (res.Data) {
            let options = []
            res.Data.map(item=>{
              if(item.invoice_list_create_flag == "1" && item.invoice_list_create_type == "1"){
                options.push({
                  label: item.customer_branch_name,
                  value: item.id
                })
              }
            })
            this.setState({
              options_branch:options
            });
          }
        })
      });
      

    } else {
      this.setRequiredData(url)
    }
    // スクロールバーを表示するように設定
    document.body.style.overflow = "auto";
  }

  setRequiredData = async (url)=>{
    const requiredCheckedData = await Request.getRequiredData(url, this.state.data)
    this.setState({
      data:requiredCheckedData
    })
  }

  validate() {
    let message = getErrorCodes(this.state.data.errors)

    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  alertDateCheck(newData){
    const {
      customer_system_start_date,
      customer_system_end_date,
      customer_system_use_flag
    } = newData.values
    const {
      customer_system_start_date:prev_customer_system_start_date,
      customer_system_end_date:prev_customer_system_end_date,
    } = this.state.data.values

    if(customer_system_use_flag == 1 ){
      if(customer_system_start_date && customer_system_end_date && (moment(customer_system_start_date) > moment(customer_system_end_date))){
        return {
          ...newData,
          errors:{
            ...newData.errors,
            customer_system_start_date:!prev_customer_system_start_date? [GetMessage(2024)] :prev_customer_system_start_date === customer_system_start_date ? undefined:[GetMessage(2492)],
            customer_system_end_date:prev_customer_system_end_date === customer_system_end_date ? undefined:[GetMessage(2492)],
          }
        }
      }else{
        return {
          ...newData,
          errors:{
            ...newData.errors,
            customer_system_start_date:!customer_system_start_date? [GetMessage(2024)] : undefined,
          }

        }
      }
  
    }else{
      return {
        ...newData,
        errors:{
          ...newData.errors,
          customer_system_start_date: undefined,
          customer_system_end_date: undefined,
        }
      };
    }

  }

  async alertNaturalIdCheck(newData, callback=()=>{}){

    let tmpData = newData;
    let {customer_natural_flag,customer_natural_id_new} = tmpData.values;
    let customer_natural_id_flag = true;
    
    if (customer_natural_flag == "1" && customer_natural_id_new != undefined && tmpData.errors.customer_natural_id_new == undefined){
      await new Promise((resolve) => {
        const {
          customer_natural_id_new,
        } = tmpData.values
        Request.get('/api/customer/check',{customer_natural_id:customer_natural_id_new}
          , res => {
          console.log(res.Data);
          if(res.Data && res.Data == "NG"){
            // this.props.alertModal.current.showErrorModal({
            //   title:'アラート',
            //   messageNo: (2505)
            // });
            customer_natural_id_flag = false;
          }else{
            customer_natural_id_flag = true;
          }
          resolve();
        },()=>{},()=>{},true,false)
      }).then(()=>{
        this.setState({
          data:{
            ...tmpData,
            requiredData : {
              ...tmpData.requiredData
            },
            errors : {
              ...tmpData.errors,
              customer_natural_id_new: customer_natural_id_flag == false? [GetMessage(2505)] : undefined,
            }
          }
        }, ()=>callback());
      });
    }else{
      // console.log(customer_natural_flag);
      if(customer_natural_flag == "0"){
        tmpData.errors.customer_natural_id_new = undefined;
        customer_natural_id_new = "";
      }

      this.setState({
        data:{
          ...tmpData,
          values:{
            ...tmpData.values,
            customer_natural_id_new
          },
          requiredData : {
            ...tmpData.requiredData
          },
          errors : {
            ...tmpData.errors,
            customer_natural_id_new: tmpData.errors.customer_natural_id_new ? tmpData.errors.customer_natural_id_new : undefined,
          }
        }
      }, ()=>callback());
    }
  }
  
  async validateCallback(newData, callback=()=>{}){

    // 顧客システム利用時のみ必須項目追加
    const { 
      customer_system_use_flag,
      customer_system_start_date,
      customer_system_end_date,
      customer_natural_flag,
      customer_natural_id_new,
      admin_user_login_id,
     } = newData.values
    console.log("validateCallback", newData);

    const {
      admin_user_login_id: state_admin_user_login_id,
      customer_natural_id_new: state_customer_natural_id_new,
      customer_natural_flag: state_customer_natural_flag
    } = this.state.data.values

    //  承認機能の値によって承認の段階の値も変更
    if(newData.values.approval == 1){
      newData.values.approval_step = newData.values.approval_step == 0 ? 1 : newData.values.approval_step;
    }else{
      newData.values.approval_step = 0;
    }
    if (customer_system_use_flag == 1 && (admin_user_login_id == "" || admin_user_login_id == null || state_admin_user_login_id == "" || state_admin_user_login_id == null)){
      console.log("admin_user_login_id", admin_user_login_id, state_admin_user_login_id)
    }

    if (customer_natural_id_new != state_customer_natural_id_new || customer_natural_flag != state_customer_natural_flag){
      this.alertNaturalIdCheck(newData,callback);
    }else{
      const mergedData = {
        ...this.state.data,
        ...this.alertDateCheck(newData),
        values:{
          ...this.state.data.values,
          ...newData.values,
        }
      }
      console.log("mergedData", mergedData)
      this.setState({
        data:{
          ...mergedData,
          requiredData : {
            ...mergedData.requiredData,
            customer_system_start_date: customer_system_use_flag == 1 ? [GetMessage(2024)] : undefined,
            admin_user_login_id: customer_system_use_flag == 1 ? [GetMessage(2024)] : undefined,
          },
          errors : {
            ...mergedData.errors,
            admin_user_login_id:customer_system_use_flag == 1 && (!admin_user_login_id) ? [GetMessage(2024)] : undefined,
          }
        }
      }, ()=>callback())
  
    }
  }

  GetCustomerLoginId(newData){
    let {customer_login_id} = newData.values
    console.log("newData", newData)
    if ( customer_login_id == null || customer_login_id == ""){
      Request.get('/api/cu_customer_option/getid',{}, res => {

        newData.values.customer_login_id = res.Data
        this.setState({
          data:{...newData}
        })
      })    
  
    }
  }

  componentDidUpdate(prevProps, prevState){
    if(this.state.data.values.customer_system_use_flag != prevState.data.values.customer_system_use_flag
      && this.state.data.values.customer_system_use_flag == "1" 
      && (prevState.data.values.customer_login_id == null || prevState.data.values.customer_login_id == "")
      ){
      this.GetCustomerLoginId(this.state.data)
    }
    if(this.state.data.values.customer_login_id != prevState.data.values.customer_login_id
      && (this.state.data.values.customer_login_id == ""))
    {

      this.props.alertModal.current.showErrorModal({
        title:'アラート',
        messageNo: (2499)
      });
      this.setState({
        data:{...prevState.data}
      })
    }

  }  

  customerSelected(customer, callback=()=>{}){
    const data = this.state.data;
    // console.log("customer", customer)
    const { 
      customer_user_email,
      customer_user_name,
      customer_user_name_kana,
      customer_reminder_sms_flag,
      customer_user_tel,
      customer_branch_id,
      customer_user_id,
     } = customer

    this.setState({
      data:{
        ...data,
        values:{
          ...data.values,
          admin_user_login_id:customer_user_email,
          login_id:customer_user_email,
          customer_user_name,
          customer_user_name_kana,
          customer_reminder_sms_flag,
          customer_user_tel,
          customer_branch_id,
          customer_user_id
        },
          errors : {
            ...data.errors,
            admin_user_login_id: undefined,
          }
      }
    }, ()=>callback())
  }

  toggleRegistModal() {
    this.setState({
      regist_modal: !this.state.regist_modal
    });
  }
  toggleBranchRegistModal(){
    if(this.props.match.params.customer_id != undefined){
      this.props.history.push('/customer?customer_natural_id='+this.state.data.values.customer_natural_id);
    }else{
      this.setState({
        branch_regist_modal: !this.state.branch_regist_modal
      });
    }
  }

  toggleDeleteModal() {
    this.setState({
      test_delete_modal: !this.state.test_delete_modal
    });
  }

  registerCoreUser = (params) => {
    var url = domain + '/api/customer';

    return new Promise((resolve, reject) => {      
      Request.post(url, params, res => {
        if(res.Data.ulid){
          this.setState({
            new_customer_id:res.Data.ulid,
            new_customer_natural_id:res.Data.customer_natural_id
          });
          resolve(res.Data)
        }else{
         const messageObj = (res.Code>=800)
            ?{messageNo:[2402,...(res.Data.length?res.Data.map(error=>error[0]):[res.Data.error])]}
            :{messageNo:2402}
          reject(messageObj)
        }
      });
    })
  }

  updateCoreUser = (params) => {
    const url = "/api/customer/" + this.props.match.params.customer_id;

    return new Promise((resolve, reject) => {
      Request.put(url, params, res => {
        if(res.Data.ulid){
          resolve(res.Data)
        }else{
          console.log(res.Data)
          const messageObj = (res.Code>=800)
            ?{messageNo:[2403,...(res.Data.length > 0?res.Data.map(error=>error[0]):[res.Data.error])]}
            :{messageNo:2403}
          reject(messageObj)
        }
      });
    })
  }

  sendAutoMail = (sendMailParams) =>{
    return new Promise((resolve, reject) => {
      const sendMailUrl = '/api/send/AUTOMAIL'
      Request.post(sendMailUrl, sendMailParams, res=> resolve(res), err=> reject(err))
    })
  }

  async regist(callback=()=>{}) {

    const isRegister = this.state.view === false
    const {
      customer_system_start_date,
      customer_system_end_date,
      admin_user_login_id
    } = this.state.data.values
    console.log(this.state.data)
    const coreUserParams = {
      ...this.state.data.values,
      ...(this.state.data.values.customer_system_use_flag==0
        ?{
          admin_user_login_id: null,
          customer_system_start_date: null,
          customer_system_end_date: null
        }:{
          admin_user_login_id: admin_user_login_id === "" ? null : this.state.data.values.admin_user_login_id,
          customer_system_start_date: customer_system_start_date === "" ? null : customer_system_start_date,
          customer_system_end_date: customer_system_end_date === "" ? null : customer_system_end_date
        }),
    }

    try {
      if(isRegister) {
        
        await this.registerCoreUser(coreUserParams)
        
        this.props.pageChangeAlert.current.inactivate();
        callback()
        
      } else {
        Request.setProgress(10)
        if(this.state.updateCoreUser){
          await this.updateCoreUser(coreUserParams)
          
          this.setState((prevState)=>{
            return{
              ...prevState,
              updateCoreUser:false
            }
          })
        }
        Request.setProgress(0)

        this.props.pageChangeAlert.current.inactivate();
        this.props.history.push(`/customer/detail/${this.props.match.params.customer_id}`)
      }  
      
    } catch (error) {
      this.props.alertModal.current.showErrorModal(error);
    }  
  }


  async delete() {
    const deleteUrl = '/api/customer/test_delete'
    Request.post(deleteUrl, {}, res=>{
      document.body.style.overflow = "auto";
      this.props.pageChangeAlert.current.inactivate();
      this.props.alertModal.current.confirmCheck({
        title: "更新が完了しました。",
        messageNo: 2507,
        closeBtn: false
      }, ()=>{
        this.props.history.push(`/customer/detail/${this.props.match.params.customer_id}`)
      }, false)
  
    })

  }

  
  button_name(){
    if(this.state.view === false){
      return "登録";
    }else{
      return "更新";
    }
  }

  set_title(){
    if(this.state.view === false){
      return "顧客マスタ新規登録";
    }
    return "顧客マスタ更新";
  }
  render() {
    console.log('state', this.state)
    var title = this.set_title();
    const ButtonWithRole = this.ButtonWithRole || WithRole(Button, this.props.buttons, this.state.data.values)
    // 顧客向け一時リリース対応
    // const isRegister = this.state.view === false
    const isRegister = this.state.view === false ? false : true
    // const isRegister = process.env.REACT_APP_CUSTOMER_SYSTEM_USE_FLAG === "1" ? this.state.view === false ? false : true : false
    const customMessage = isRegister ? customMessages["customer_system_use_flag"] : ""

    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <CardTitle tag="h3">{title}</CardTitle>
                </CardHeader>
                <Col md="11" className="detail">
                <ApprovedInfo
                  rootData={this.state.data}
                  validateCallback={this.validateCallback}
                  employeeType={this.state.employeeType}
                  visible={this.state.view}
                  isEdit={true}
                />  

                <SystemInfo
                    id_title='会社ID'
                    id_value={this.state.data.values.customer_natural_id}
                    update_timestamp={this.state.data.values.update_timestamp}
                    update_user={this.state.data.values.lastupdate_user && this.state.data.values.lastupdate_user.name}
                    update_user_picture={this.state.data.values.lastupdate_user && this.state.data.values.lastupdate_user.picture}
                    visible={this.state.view} />
                  <CardTitle tag="h4">管理情報</CardTitle>
                  <Table>
                    <tbody>
                      <tr>
                        {/* <th>管理情報</th> */}
                        <CustomTd label='メモ'
                          name='CUSTOMER__system_memo'
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputText multiline={true}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                        />
                      </tr>
                      {this.state.view === true  && 
                          <tr>
                            <CustomTd label='削除フラグ'
                              name='CUSTOMER__delete_flag'
                              copy={false}
                              value={
                                <InputCheckBox 
                                  validateCallback={this.validateCallback} 
                                  checkedValue={1}
                                  uncheckedValue={0}
                                  rootData={this.state.data}
                                />
                              }
                            />

                          </tr>
                        }
                        {this.state.view === true && this.state.delete_support_flg === true && 
                          <tr>
                          <CustomTd label='テストデータ'
                            name='delete_support_flg'
                            copy={false}
                            value={
                              <Button
                              className="mt-2"
                              onClick={()=>this.toggleDeleteModal()}
                            >
                              テストデータ削除
                            </Button>
                            }
                          />
                          </tr>
                        }
                    </tbody>
                  </Table>

                  <CardTitle tag="h4">会社情報</CardTitle>
                  <Table>
                    <tbody>
                      {this.state.view === false &&
                      <tr>
                        <CustomTd label='会社ID手動設定'
                          name='CUSTOMER__customer_natural_flag'
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputRadio
                              options={cst_customer_natural_flag}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                        />                        
                      </tr>
                      }
                      {this.state.view === false &&
                      <tr>
                        {/* <th rowSpan="2">会社情報</th> */}
                        <CustomTd label='会社ID'
                          name='CUSTOMER__customer_natural_id_new'
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputText
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                              hasKanaInput={true}
                              disabled={this.state.data.values.customer_natural_flag == 1 ? false : true}
                            />
                          }
                        />
                      </tr>
                      }
                      <tr>
                        {/* <th rowSpan="2">会社情報</th> */}
                        <CustomTd label='会社名'
                          name='CUSTOMER__customer_name'
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputText
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                              hasKanaInput={true}
                            />
                          }
                        />
                      </tr>
                      <tr>
                        <CustomTd label='会社名（カナ）'
                          name='CUSTOMER__customer_name_kana'
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputText
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                        />
                      </tr>
                      <tr>
                        <CustomTd label='工事番号必須フラグ'
                          name='CUSTOMER__construction_number_require_flag'
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputRadio
                              options={cst_construction_number_require_flag}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                        />
                      </tr>
                      <tr>
                        <CustomTd label='一覧請求設定：メイン支店'
                          name='CUSTOMER__invoice_list_customer_branch_id'
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputSelect
                              options={this.state.options_branch}
                              validateCallback={this.validateCallback} 
                              rootData={this.state.data} 
                              validateType='regist'
                              disabled={this.state.options_branch.length < 1}
                            />
                          }
                        />
                      </tr>
                    </tbody>
                  </Table>
                  <CardTitle tag="h4">顧客向けシステム利用情報</CardTitle>
                  <Table >
                    <tbody>
                      <tr>
                        <CustomTd label='顧客向け利用有無'
                          name='CUSTOMER__customer_system_use_flag'
                          copy={false}
                          rootData={this.state.data}
                          colSpan="8"
                          value={
                            <InputRadio
                              options={cst_customer_system_use_flag}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                              disabled={!isRegister}
                              customMessage={customMessage}
                            />
                          }
                        />
                      </tr>
                      {this.state.data.values.customer_system_use_flag==1&&<tr>
                        <CustomTd label='顧客システム利用開始日'
                            name='CUSTOMER__customer_system_start_date'
                            copy={false}
                            rootData={this.state.data}
                            colSpan="8"
                            value={
                              <InputDatetime
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                              />
                            }
                        />
                      </tr>}
                      {this.state.data.values.customer_system_use_flag==1&&<tr>
                        <CustomTd label='顧客システム利用終了日'
                            name='CUSTOMER__customer_system_end_date'
                            copy={false}
                            rootData={this.state.data}
                            colSpan="8"
                            value={
                              <InputDatetime
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                              />
                            }
                        />
                      </tr>}
                      {this.state.data.values.customer_system_use_flag==1&&<tr>
                        <CustomTd label='承認機能利用'
                            name='CU_CUSTOMER_OPTION__approval'
                            copy={false}
                            rootData={this.state.data}
                            colSpan="2"
                            value={
                              <InputRadio
                                options={cst_cu_customer_option_approval}
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                              />
                            }
                        />
                        {Number(this.state.data.values.approval) > 0 &&
                          <CustomTd label='承認の段階'
                              name='CU_CUSTOMER_OPTION__approval_step'
                              copy={false}
                              rootData={this.state.data}
                              colSpan="1"
                              value={
                                <InputRadio
                                  options={cst_cu_customer_option_approval_step}
                                  validateCallback={this.validateCallback} 
                                  validateType='regist'
                                />
                              }
                          />
                        }
                      </tr>}
                      {this.state.data.values.customer_system_use_flag==1&&<tr>
                        <CustomTd label='データ閲覧制限'
                            name='CU_CUSTOMER_OPTION__data_scope'
                            copy={false}
                            rootData={this.state.data}
                            colSpan="8"
                            value={
                              <InputRadio
                                options={cst_cu_customer_option_data_scope}
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                              />
                            }
                        />
                      </tr>}
                      {this.state.data.values.customer_system_use_flag==1&&<tr>
                        <CustomTd label='会社ログインID'
                            name='CU_CUSTOMER_OPTION__customer_login_id'
                            copy={false}
                            rootData={this.state.data}
                            colSpan="8"
                            value={
                              <InputText
                              rootData={this.state.data}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            /> 
                            }
                        />
                      </tr>}                      
                      {this.state.data.values.customer_system_use_flag==1&&<tr>
                        <CustomTd label='システム管理者'
                          name='CU_CUSTOMER_OPTION__admin_user_login_id'
                          copy={false}
                          rootData={this.state.data}
                          colSpan="8"
                          value={
                            <>
                              <InputText
                                rootData={this.state.data}
                                label='システム管理者'
                                name='CU_CUSTOMER_OPTION__admin_user_login_id'
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                                disabled={true}
                              />
                              <Button
                                className="mt-2"
                                onClick={()=>this.customer_select_popup.current.show()}
                              >
                                担当者から選択
                              </Button>
                            </>
                          }
                        />
                      </tr>}
                      {this.state.data.values.customer_system_use_flag==1&&<tr>
                        <CustomTd label='支店一括更新'
                            name='NODB__customer_branch_update_type'
                            copy={false}
                            rootData={this.state.data}
                            colSpan="8"
                            value={
                              <InputRadio
                                options={cst_customer_branch_update_type}
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                                customMessage={"※利用無の支店は利用有として更新されます"}
                              />
                            }
                        />
                      </tr>}
                    </tbody>
                  </Table>

                  <Row md="12">
                    <Col md="6" className="text-center">
                      <Button color="secondary" onClick={() => { 
                        if(this.state.view === false){
                          this.props.history.push('/customer') 
                        } else {
                          this.props.history.push(`/customer/detail/${this.props.match.params.customer_id}`) 
                        }
                      }}>キャンセル</Button>
                    </Col>
                    <Col md="6" className="text-center">
                      <ButtonWithRole
                        button_id={this.state.view?"BTN_M1_08_04090":"BTN_M1_02_03830"}
                        color="info"
                        onClick={() => {
                          if(this.validate()){
                            this.toggleRegistModal()
                          }
                        }}
                      >{this.button_name()}</ButtonWithRole>
                    </Col>
                  </Row>
                </Col>
              </Card>
            </Col>
          </Row>
        </div>
        <Modal isOpen={this.state.regist_modal} toggle={this.toggleRegistModal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleRegistModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">{this.button_name()}</h5>
          </div>
          <ModalBody>
            <p>{this.button_name()}しますか？</p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleRegistModal}>
              いいえ
            </Button>
            <ButtonWithRole
              button_id={this.state.view?"BTN_M1_08_04110":"BTN_M1_02_03850"}
              color="info" 
              onClick={() => {this.toggleRegistModal(); this.regist(this.toggleBranchRegistModal)}}>
              はい
            </ButtonWithRole>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.branch_regist_modal} toggle={this.toggleBranchRegistModal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleBranchRegistModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">{this.button_name()}</h5>
          </div>
          <ModalBody>
            <p>顧客マスタに会社を登録致しました。続いて支店を登録しますか？</p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={()=>this.props.history.push('/customer?customer_natural_id='+this.state.new_customer_natural_id)}>
              いいえ
            </Button>
            <ButtonWithRole 
              button_id="BTN_M1_02_03870"
              color="info" 
              onClick={() => { this.props.history.push('/customer/add/branch/'+this.state.new_customer_id) }}>
              はい
            </ButtonWithRole>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.test_delete_modal} toggle={this.toggleDeleteModal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleDeleteModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">データ削除</h5>
          </div>
          <ModalBody>
            <p>テストデータを削除しますか？</p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleDeleteModal}>
              いいえ
            </Button>
            <ButtonWithRole
              color="info" 
              onClick={() => {this.toggleDeleteModal(); this.delete()}}>
              はい
            </ButtonWithRole>
          </ModalFooter>
        </Modal>

        <AdminCustomerSelectPopup 
          buttons={this.props.buttons}
          view={this.state.view}
          ref={this.customer_select_popup} 
          customerSelectedCallback={(customer)=>this.customerSelected(customer)}
          customerId={this.props.match.params.customer_id}
          {...this.props}
        />   
        <AdminCustomerSelectPopup 
          buttons={this.props.buttons}
          view={this.state.view}
          ref={this.customer_testdata_delete_popup} 
          customerSelectedCallback={(customer)=>this.customerSelected(customer)}
          customerId={this.props.match.params.customer_id}
          {...this.props}
        />   

        
      </>
    );
  }
}

export default Regist;
